export const ADVANCE_DRAW_TYPE = "Advance Amount";

const INSPECTION_REPORT_TAG_CODES = new Set(["TRRE", "DDDC", "SIRE", "ADRF"]);
const INSPECTION_TAG_CONFIDENCE_THRESHOLD = 0.9;

export function isAdvanceDraw(drawType: string | undefined): boolean {
  return drawType === ADVANCE_DRAW_TYPE;
}

function getDocTagCode(doc: any): string | undefined {
  const directCode = doc?.tags?.code;
  if (directCode) return directCode;

  const nestedTags = doc?.tags;
  if (Array.isArray(nestedTags)) {
    const match = nestedTags.find((tag: any) => tag?.tag?.code);
    if (match?.tag?.code) return match.tag.code;
  }

  const tagsInternal = doc?.TagsInternal;
  if (Array.isArray(tagsInternal)) {
    const match = tagsInternal.find((tag: any) => tag?.tag?.code);
    if (match?.tag?.code) return match.tag.code;
  }

  return undefined;
}

function getDocTagConfidence(doc: any): number {
  if (typeof doc?.tags?.confidenceScore === "number") {
    return doc.tags.confidenceScore;
  }

  const nestedTags = doc?.tags;
  if (Array.isArray(nestedTags)) {
    const score = nestedTags.find((tag: any) => tag?.confidenceScore != null)?.confidenceScore;
    if (typeof score === "number") return score;
  }

  const tagsInternal = doc?.TagsInternal;
  if (Array.isArray(tagsInternal)) {
    const score = tagsInternal.find((tag: any) => tag?.confidenceScore != null)?.confidenceScore;
    if (typeof score === "number") return score;
  }

  return 1;
}

export function hasInspectionReportDocument(inspectionDocs: any[] = []): boolean {
  return inspectionDocs.some((doc) => {
    const code = getDocTagCode(doc);
    if (!code || !INSPECTION_REPORT_TAG_CODES.has(code)) return false;
    return getDocTagConfidence(doc) > INSPECTION_TAG_CONFIDENCE_THRESHOLD;
  });
}

export function isAdvanceDrawWithNoInspection(
  drawType: string | undefined,
  inspectionDocs: any[] = []
): boolean {
  return isAdvanceDraw(drawType) && !hasInspectionReportDocument(inspectionDocs);
}
